import NewHeader from '@/web-common-shared-components/components/new-header.vue';

export const PROVIDE: Record<string, InjectionKey<Ref<InstanceType<typeof NewHeader> | null>>> = {
  HEADER_REF_WITHIN_SHOW_LOGIN_POP: Symbol(
    'you can use the functions or variables of the login component by inject it, such as showLoginPop, hideCloseBtn, showLogin',
  ),
};
